export default __webpack_public_path__ + "static/media/img-0090-china-full-face.ac94a3bb.png";